import * as React from "react";
import { useTranslation } from "react-i18next";
import CommonContainer from "../../components/common/container/CommonContainer";
import ViewShopRenderer from "../../components/Admin/view/ViewShopRenderer";


const ViewShop: React.FC = () => {

    const { t } = useTranslation('translation');
    return (
            <CommonContainer title={t("shopDetails")} description={t("viewShopDetails")} backButtonurl= "/admin/shopList">
                <ViewShopRenderer />
            </CommonContainer>
    );
};

export default ViewShop;
